export default __webpack_public_path__ + "static/media/MATIC.6f0f35d3.svg";